type Props = {
    dirty: boolean;
    isSaving: boolean;
    saveError: string | null;
    onSave: () => void;
    onDiscard: () => void;
};

const MentorProfileHeader = ({ dirty, isSaving, saveError, onSave, onDiscard }: Props) => (
    <>        
        <div className="d-flex flex-wrap align-items-start justify-content-between mb-4 gap-3">
            <div>
                <h4 className="font-22 font-600 mb-1 text-dark">My Mentor Profile</h4>
                <div className="text-secondary small">This is how your mentees see you · Keep your tracks and availability up to date</div>
            </div>
            <div className="d-flex gap-2">               
                <button type="button" className="btn btn-sm btn-outline-secondary font-500 rounded-pill px-3" disabled={!dirty || isSaving} onClick={onDiscard}>Discard</button>
                <button type="button" className="btn btn-sm btn-primary font-500 rounded-pill px-3" disabled={!dirty || isSaving} onClick={onSave}><span >{isSaving ? 'Saving…' : '💾 Save Profile'}</span></button>
            </div>
            {saveError ? <p className="mprof-save-error">{saveError}</p> : null}
        </div>
    </>
    
);

export default MentorProfileHeader;
